import { ListItemButton, ListItemText, Paper, Typography } from '@mui/material';
import { PolicyRule } from '../../model/interfaces/policyRule';

interface ClickableRuleProps {
  rule: PolicyRule;
  onSelectRule: (rule: PolicyRule) => void;
  selected: boolean;
}

const RuleListItem = (props: ClickableRuleProps) => {
  const { rule, onSelectRule, selected } = props;
  return (
    <ListItemButton
      selected={selected}
      onClick={() => onSelectRule(rule)}
      component={Paper}
      variant="outlined"
      elevation={0}
      sx={{
        backgroundColor: '#fff',
        border: '1px solid #E3E2DE',
        paddingY: 1,
        paddingX: 1.25,
        borderRadius: '6px',
        '&:hover': { borderColor: '#3B82F6', backgroundColor: '#fff' },
        '&.Mui-selected, &.Mui-selected:hover': { borderColor: '#3B82F6', backgroundColor: '#F5F9FF' }
      }}>
      <ListItemText
        sx={{ margin: 0 }}
        secondaryTypographyProps={{
          sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
          noWrap: true
        }}
        primaryTypographyProps={{
          sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
          noWrap: true
        }}
        primary={<Typography variant={'body2'}>{rule.name}</Typography>}
        secondary={<Typography variant={'caption'}>{rule.description}</Typography>}
      />
    </ListItemButton>
  );
};

export default RuleListItem;
